









import { Component, Prop, Vue } from 'vue-property-decorator';
import ProgressBar from 'progressbar.js';

@Component({
  mixins: [],
  components: {},
})
export default class AudioUploadProgressComponent extends Vue {
  @Prop({ default: 'progress-bar-component' })
  elementId: string;

  @Prop({ default: 'progress' })
  classNames: string;

  @Prop({ default: '#FFFFFF' })
  color: string;

  @Prop({ default: 150 })
  duration: number;

  @Prop({ default: 0 })
  pctComplete: number;

  progressBar: any;

  mounted() {
    this.progressBar = new ProgressBar.Line('#audio-upload-progress', {
      color: this.color,
      duration: this.duration,
      easing: 'linear',
      strokeWidth: 5,
      svgStyle: { width: '100%', height: '100%' },
    });
    if (this.pctComplete > 0) {
      this.progressBar.animate(this.pctComplete / 100, { duration: this.duration });
    }
  }

  updated() {
    if (this.progressBar) {
      this.progressBar.animate(this.pctComplete / 100, { duration: this.duration });
    }
  }

  beforeDestroy() {
    if (this.progressBar) {
      this.progressBar.destroy();
    }
  }
}
